import React from "react";
import Carousel from 'react-bootstrap/Carousel'
import './portfolio-design.css'
//import 'bootstrap/dist/css/bootstrap.min.css';

//import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
//import { Carousel } from 'react-responsive-carousel';
//import Carousel from 'react-material-ui-carousel'
const Portfolio = ({ data }) => {
  // if (data) {
  //   var projects = data.projects.map(function (projects) {
  //     var projectImage = "images/portfolio/" + projects.image;
  //     return (
  //       <div key={projects.title} className="columns portfolio-item">
  //         <div className="item-wrap">
  //           <a href={projects.url} title={projects.title} target='_blank'>
  //             <img alt={projects.title} src={projectImage} />
  //             <div className="overlay">
  //               <div className="portfolio-item-meta">
  //                 <h5>{projects.title}</h5>
  //                 <p>{projects.category}</p>
  //               </div>
  //             </div>
  //             <div className="link-icon">
  //               <i className="fa fa-link"></i>
  //             </div>
  //           </a>
  //         </div>
  //       </div>
  //     );
  //   });
  // }
    const projects= [
      {
        "title": "Colour Generator (React JS)",
        "category": "Front End Web Development",
        "image": "colourgen.jpg",
        "url": "https://reactcolorgeneratorproject.netlify.app/"
      },
      // {
      //   "title": "Mern Social Media App, Memories",
      //   "category": "Full stack Web development. PS: Uses a different database. Not authored by me.",
      //   "image": "memories.jpg",
      //   "url": "https://memories-social-mern.netlify.app/posts"
      // },
      {
        "title": "Hulu Clone (React JS)",
        "category": "Front End Web Development",
        "image": "huluclone.jpg",
        "url": "https://hulu-clone-flax-two.vercel.app/"
      },
      {
        "title": "Apartment Management WebApp",
        "category": "Front End Web Development",
        "image": "apnaghar.jpg",
        "url": "https://github.com/sahanashettigar/WEB_TECH_PROJECT-1"
      },
      {
        "title": "Stage Time",
        "category": "UI App Design on Adobe XD",
        "image": "stagetime.jpg",
        "url": "https://xd.adobe.com/view/04d18b9f-20b6-4734-98c3-b703ed0b5b7d-5182/"
      },
      {
        "title": "PlannAR, AR Event App",
        "category": "UI App Design on Figma",
        "image": "plannar.jpg",
        "url": "https://www.figma.com/file/O9ZfCANxyvs1uW7j9dp9Gy/PlannAR?node-id=0%3A1"
      },
      {
        "title": "Essess HR Talent Sourcing",
        "category": "UI Web Design on Figma",
        "image": "essess.jpg",
        "url": "https://www.figma.com/file/caeko26oOAEWqigW5gIoIZ/essess?node-id=0%3A1"
      },
      {
        "title": "Better Me - Task List Management",
        "category": "UI App Design on Figma",
        "image": "betterme.jpg",
        "url": "https://www.figma.com/proto/DpFGfARmINa6BEO3jx3vMl/Better-Me---Task?node-id=0%3A1&scaling=scale-down&page-id=0%3A1&starting-point-node-id=31%3A244&show-proto-sidebar=1"
      }
    ]
  return (
    <section id="portfolio">
      <div className="row">
        <div>
          <h1 className="text-center"  >Check Out Some of My Works.</h1>

          {/* <div
            id="portfolio-wrapper"
            className="bgrid-quarters s-bgrid-thirds cf">
            {projects}
          </div> */}
      {/* <Carousel fade className="justify-content-center"> */}
        {projects.map(project => (
          <Carousel.Item key={project.title} className="align-center">
          <a href={project.url} title={project.title} target='_blank'>
            <img
              className=" d-block w-50 img__wrap"
              src={`images/portfolio/${project.image}`}
              alt={project.author}
              width="900px"
            />
            {/* <p class="img__description">This image looks super neat.</p> */}
          </a>
            <Carousel.Caption>
              <h3>{project.title}</h3>
              <p>{project.category}</p>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      {/* </Carousel> */}
        </div>
      </div>
    </section>
  );

};

export default Portfolio;
